
// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| AUDITORIA LOGS MENU ITEMS ||============================== //

const auditoria = {
    id: 'auditoria',
    title: 'Auditoria Logs',
    type: 'group',
    children: [
        {
            id: 'logs',
            title: 'Logs',
            type: 'item',
            icon: icons.IconMessages,
            url: '/logs/log-system'
        },
    ]
};

export default auditoria;
